var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "支付信息",
        visible: _vm.centerDialogVisible,
        width: "30%",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.centerDialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c("div", { staticClass: "line" }, [
            _c("p", [_vm._v("原订单已退款金额：")]),
            _vm._v(" "),
            _c("span", [_vm._v("¥ " + _vm._s(_vm.datas.oldOrderRefundPrice))]),
          ]),
          _c("div", { staticClass: "line" }, [
            _c("p", [_vm._v("当前订单金额：")]),
            _vm._v(" "),
            _c("span", [_vm._v("¥ " + _vm._s(_vm.datas.orderPrice))]),
          ]),
          _c("div", { staticClass: "line" }, [
            _c("p", [_vm._v("原订单Id：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.datas.parentId))]),
          ]),
          _c("div", { staticClass: "line" }, [
            _c("p", [_vm._v("原订单的支付方式：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.mapPayMode[_vm.datas.payMode]))]),
          ]),
          _c("div", { staticClass: "line" }, [
            _c("p", [_vm._v("原订单是否已支付：")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.datas.isPay ? "已支付" : "未支付"))]),
          ]),
          _c("p", { staticStyle: { color: "red" } }, [
            _vm._v("点击确定之后原订单将会被取消"),
          ]),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.centerDialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.pay } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }